import { CAST_AI, CAST_PILOT_ASSISTANT } from '@cast/constants';
import { Button, Icons, MarketingBanner } from '@cast/design-system';

import { useChatbotState } from '@cast/features-organization-shared-opspilot';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const CAST_AI_CHATBOT_BANNER_ID = 'new-cast-ai-chatbot';

export const CastAIChatbotBanner = ({ onClose }: { onClose: () => void }) => {
  const { open } = useChatbotState();
  const { currentOrganization } = useOrganizations();

  return (
    <MarketingBanner
      testId={CAST_AI_CHATBOT_BANNER_ID}
      title={`Introducing ${CAST_PILOT_ASSISTANT}`}
      message={`Get instant answers, automation tips, and insights across your clusters, workloads, and ${CAST_AI} features — all powered by AI.`}
      onClose={onClose}
      action={
        <Button
          size="sm"
          endIcon={<Icons.ArrowRight />}
          onClick={() => {
            open(currentOrganization?.id ?? 'default');
          }}
        >
          Try it now
        </Button>
      }
    />
  );
};
